import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import navbar from './navbar/index'

const rootReducer = combineReducers({
  navbar,
  router: routerReducer
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js